import React from "react";
import { Lock } from "lucide-react";
import { usePhysicsAuthoringLock } from "../../utils/physicsGuards";

export default function PhysicsAuthoringLockNotice({
  actionText = "Scene editing is locked while physics is on.",
  className = "",
}) {
  const locked = usePhysicsAuthoringLock();
  if (!locked) return null;

  return (
    <div
      className={[
        "flex items-start gap-2 rounded-md border border-amber-500/30 bg-amber-500/10 px-2.5 py-2 text-xs text-amber-100",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      role="status"
      aria-live="polite"
    >
      <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-200" aria-hidden="true" />
      <span className="min-w-0 leading-snug">{actionText}</span>
    </div>
  );
}
